import { Outlet, Link, useLocation } from 'react-router-dom'
import { useState } from 'react'

export default function Layout() {
  const location = useLocation()
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)

  const navLinks = [
    { path: '/#equipment', label: 'Solutions' },
    { path: '/sludge-dewatering-equipment', label: 'Sludge Dewatering' },
    { path: '/sourcing-capabilities', label: 'Capabilities' },
    { path: '/projects', label: 'Projects' },
    { path: '/insights', label: 'Insights' },
    { path: '/work-with-grace', label: 'Work With Grace' },
  ]

  return (
    <>
      <header className="site-header">
        <div className="header-inner">
          <Link to="/" className="brand" aria-label="Yixing Environmental Equipment Supply home">
            <span className="brand-mark">YE</span>
            <span className="brand-copy">
              <strong>YIXING ENVIRONMENTAL</strong>
              <small>EQUIPMENT SUPPLY</small>
            </span>
          </Link>

          <button
            className="mobile-menu-btn"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="Toggle menu"
          >
            Menu
          </button>

          <nav className={`desktop-nav ${mobileMenuOpen ? 'open' : ''}`} aria-label="Main navigation">
            {navLinks.map(link => (
              <Link
                key={link.path}
                to={link.path}
                className={location.pathname === link.path ? 'active' : ''}
                onClick={() => setMobileMenuOpen(false)}
              >
                {link.label}
              </Link>
            ))}
            <Link to="/contact" className="nav-cta">
              Contact <span>↗</span>
            </Link>
          </nav>
        </div>
      </header>

      <main>
        <Outlet />
      </main>

      <footer className="site-footer">
        <div className="footer-inner">
          <div className="footer-brand">
            <strong>YIXING ENVIRONMENTAL</strong>
            <small>EQUIPMENT SUPPLY</small>
          </div>
          <p>Project-specific environmental equipment supply and project coordination in China from Yixing.</p>
          <div className="footer-links">
            <Link to="/sludge-dewatering-equipment">Sludge Dewatering</Link>
            <Link to="/wastewater-treatment-equipment">Wastewater Equipment</Link>
            <Link to="/odor-control-equipment">Odor Control</Link>
            <Link to="/sourcing-capabilities">All Capabilities</Link>
          </div>
          <div className="footer-contact">
            <a href="mailto:gracewang.environmental@gmail.com">Email</a>
            <a href="https://wa.me/..." target="_blank" rel="noopener noreferrer">WhatsApp</a>
          </div>
          <p className="footer-location">Yixing, Jiangsu, China</p>
        </div>
      </footer>
    </>
  )
}
